module.exports = __webpack_public_path__ + "img/field.204251b4.jpg";